<!--
  PC 页脚（设计基准 1920，px 经 pxtorem → rem）
-->
<template>
  <footer class="pc-footer">
    <div class="pc-footer-inner">
      <div class="pc-footer-row">
        <div class="pc-footer-left">
          <div class="pc-footer-mascot">
            <img
              src="@/assets/image/logo/app.webp"
              :alt="footerImgAlt.appIcon"
              class="pc-footer-mascot-img"
              width="96"
              height="96"
              decoding="async"
            />
          </div>
          <div class="pc-footer-download">
            <div class="pc-footer-download-inner">
              <p class="pc-footer-app-label">
                {{ pcFooterCopy.appDownloadLabel }}
              </p>
              <div class="pc-footer-deco-line" aria-hidden="true" />
            </div>
            <div class="pc-footer-badges">
              <div class="pc-footer-badges-inner">
                <a
                  :href="pcFooterLinks.appStore"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="pc-footer-badge"
                >
                  <img
                    src="@/assets/image/logo/AppStore.webp"
                    :alt="footerImgAlt.appStoreBadge"
                    class="pc-footer-badge-img"
                    width="156"
                    height="48"
                    decoding="async"
                  />
                </a>
                <a
                  :href="pcFooterLinks.googlePlay"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="pc-footer-badge"
                >
                  <img
                    src="@/assets/image/logo/GooglePlay.webp"
                    :alt="footerImgAlt.googlePlayBadge"
                    class="pc-footer-badge-img"
                    width="168"
                    height="48"
                    decoding="async"
                  />
                </a>
              </div>

              <div class="pc-footer-partner-inner">
                <a
                  :href="pcFooterLinks.yostar"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="pc-footer-partner"
                >
                  <img
                    src="@/assets/image/logo/YOSTAR.webp"
                    :alt="footerImgAlt.yostarWordmark"
                    class="pc-footer-partner-img"
                    width="140"
                    height="32"
                    decoding="async"
                  />
                </a>
                <a
                  :href="pcFooterLinks.nexon"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="pc-footer-partner"
                >
                  <img
                    src="@/assets/image/logo/NEXON.webp"
                    :alt="footerImgAlt.nexonWordmark"
                    class="pc-footer-partner-img"
                    width="160"
                    height="32"
                    decoding="async"
                  />
                </a>
              </div>

              <nav
                class="pc-footer-legal"
                :aria-label="pcFooterCopy.legalNavAriaLabel"
              >
                <span
                  v-for="(link, i) in footerLegalLinks"
                  :key="'pc-footer-legal-row-' + i"
                  class="pc-footer-legal-group"
                >
                  <a
                    :href="link.href"
                    class="pc-footer-legal-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{ link.label }}
                  </a>
                  <span
                    v-if="i < footerLegalLinks.length - 1"
                    class="pc-footer-legal-sep"
                    aria-hidden="true"
                  >
                    |
                  </span>
                </span>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <p class="pc-footer-copy">{{ pcFooterCopy.copyrightLine }}</p>
    </div>
  </footer>
</template>

<script>
import indexContent from "@/views/data/index-content.json";

const PC_FOOTER = indexContent.pcFooter;

/**
 * PC 页脚：文案与链接维护 index-content.json → pcFooter（图片在模板写死）
 */
export default {
  name: "PcFooter",

  data() {
    return {
      pcFooterCopy: PC_FOOTER.pcFooterCopy,
      pcFooterLinks: PC_FOOTER.pcFooterLinks,
      footerLegalLinks: PC_FOOTER.footerLegalLinks,
      footerImgAlt: PC_FOOTER.imgAlt,
    };
  },
};
</script>

<style lang="scss" scoped>
/* 图片：统一盒模型与基线；具体 object-fit 由各子块覆盖（吉祥物为 cover） */
.pc-footer {
  position: relative;
  /* 高于首页固定层 pc-index__news-global-bg(0) / pc-index__dj-global-bg(1)，避免被盖住 */
  z-index: 3;
  width: 100%;
  background: #1f1f1f;
  box-sizing: border-box;
  /* 大屏接近 1920 稿，窄屏随视口收紧 */
  padding: 77px 122px 126px;

  img {
    box-sizing: border-box;
    vertical-align: middle;
  }

  &-inner {
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
  }

  &-row {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 32px 40px;
    margin-bottom: 40px;
    min-width: 0;
  }

  &-left {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 24px;
    flex: 1 1 0;
    min-width: 0;
  }

  &-download {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    flex: 1 1 240px;
    min-width: 0;
    gap: 10px;

    &-inner {
      display: flex;
      align-items: center;
      gap: 8px 13px;
      max-width: 100%;
    }
  }

  &-mascot {
    flex-shrink: 0;
    width: 96px;
    height: 96px;
    min-width: 96px;
    min-height: 96px;
    border-radius: 8px;
    overflow: hidden;
    background: transparent;

    &-img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &-app-label {
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.2;
    color: #36e9ff;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    white-space: nowrap;
  }

  &-deco-line {
    flex: 1 1 80px;
    min-width: 148px;
    max-width: 168.57px;
    height: 1px;
    background: #36e9ff;
  }

  /* 商店标 + 合作方 + 法务链接：同一流式行内，放不下则换行 */
  &-badges {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px 20px;
    width: 100%;
    min-width: 0;

    &-inner {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 350px;
    }
  }

  &-partner-inner {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: flex-start;
    gap: 12px 20px;
  }

  &-badge {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 44px;
    min-height: 44px;
    flex-shrink: 0;

    &:hover,
    &:active {
      opacity: 0.85;
    }

    &:focus-visible {
      outline: 2px solid #36e9ff;
      outline-offset: 3px;
      border-radius: 6px;
    }

    &-img {
      display: block;
      width: auto;
      height: auto;
      /* 设计稿约高 47.72，窄屏 rem 变小时用下限保证可辨 */
      min-height: 40px;
      min-width: 108px;
      max-height: 52px;
      max-width: 100%;
      object-fit: contain;
    }
  }

  /* App Store / Google Play：随视口抬升最小尺寸，避免徽章缩得过小看不清 */
  @media (max-width: 1760px) {
    .pc-footer-badge-img {
      min-height: 41px;
      min-width: 112px;
    }
  }

  @media (max-width: 1600px) {
    .pc-footer-badge-img {
      min-height: 42px;
      min-width: 116px;
    }

    .pc-footer-badge {
      min-width: 120px;
      min-height: 48px;
    }
  }

  @media (max-width: 1440px) {
    .pc-footer-badge-img {
      min-height: 43px;
      min-width: 118px;
      max-height: 54px;
    }
  }

  @media (max-width: 1280px) {
    .pc-footer-badge-img {
      min-height: 44px;
      min-width: 122px;
    }
  }

  @media (max-width: 1200px) {
    .pc-footer-badge-img {
      min-height: 45px;
      min-width: 124px;
      max-height: 56px;
    }
  }

  @media (max-width: 1024px) {
    .pc-footer-badge-img {
      min-height: 46px;
      min-width: 128px;
    }

    .pc-footer-badge {
      min-width: 132px;
      min-height: 50px;
    }
  }

  @media (max-width: 900px) {
    .pc-footer-badge-img {
      min-height: 47px;
      min-width: 132px;
      max-height: 58px;
    }
  }

  @media (max-width: 768px) {
    .pc-footer-badge-img {
      min-height: 48px;
      min-width: 136px;
      max-height: 60px;
    }

    .pc-footer-badge {
      min-width: 140px;
      min-height: 52px;
    }
  }

  &-partner {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 44px;
    min-height: 44px;
    flex-shrink: 0;

    &:hover,
    &:active {
      opacity: 0.85;
    }

    &:focus-visible {
      outline: 2px solid #36e9ff;
      outline-offset: 3px;
      border-radius: 6px;
    }

    &-img {
      display: block;
      height: 32px;
      width: auto;
      max-width: min(180px, 28vw);
      object-fit: contain;
    }
  }

  /* 每组 = 链接 + 其后分隔符（末组无竖线），保持与原先平铺 flex 子项一致的排布 */
  &-legal-group {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
  }

  /* 整条法务导航不换行；作为 flex 子项宽度为内容宽，当前行放不下时整组落到下一行 */
  &-legal {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    flex: 0 0 auto;
    min-width: max-content;
    max-width: 100%;
    box-sizing: border-box;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    color: #e5e5e5;
    /* 极窄屏仍窄于整条链接时允许横向滑动，避免拆散单个 tab */
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
    }

    &-link {
      color: #e5e5e5;
      text-decoration: none;
      padding: 4px 6px;
      border-radius: 4px;
      white-space: nowrap;

      &:hover,
      &:active {
        color: #fff;
        text-decoration: underline;
      }

      &:focus-visible {
        outline: 2px solid #36e9ff;
        outline-offset: 2px;
        color: #fff;
      }
    }

    &-sep {
      color: #a3a3a3;
      user-select: none;
      padding: 0 4px;
      flex-shrink: 0;
    }
  }

  &-copy {
    text-align: center;
    font-size: 14px;
    line-height: 1.5;
    color: #fff;
  }
}
</style>
